import { UtilizationBetTypeEventDto } from '@core/mappers/bonus/dtos/BetEligibilityDto';
import UtilizationBetType from '@core/models/bonus/UtilizationBetType';

export function transformUtilizationBetType(dto: UtilizationBetTypeEventDto): UtilizationBetType {
    return {
        id: dto.ExternalBetTypeId,
        name: dto.BetTypeName,
    };
}
